import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CropMarksProps {
    className?: string
}

// Printer's crop marks on the four corners of a frame. Purely decorative.
const CropMarks: FC<CropMarksProps> = ({ className }): ReactNode => {
    const mark = 'absolute size-3 border-current'

    return (
        <span aria-hidden='true' className={cn('pointer-events-none absolute -inset-2.5', className)}>
            <span className={cn(mark, 'left-0 top-0 border-l border-t')} />
            <span className={cn(mark, 'right-0 top-0 border-r border-t')} />
            <span className={cn(mark, 'bottom-0 left-0 border-b border-l')} />
            <span className={cn(mark, 'bottom-0 right-0 border-b border-r')} />
        </span>
    )
}

export default CropMarks
